import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Products2Cell } from "@treeosk/common";
import queries from "../../../queries";
import SpecificCellPreview from "./SpecificCellPreview";

class Products2CellPreview extends React.Component {

    render() {
        const { cell } = this.props;
        const defaultRender = () => <FontAwesomeIcon icon={['far', 'address-card']} />;

        return (
            <SpecificCellPreview
                cell={cell}
                defaultRender={defaultRender}
                query={queries.cells.products2.get}
                renderingCondition={() => true}
            >
                {(products2Cell) => <Products2Cell preview={true} cell={products2Cell} />}
            </SpecificCellPreview>
        );
    }

}

export default Products2CellPreview;
